var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.7368,
    height: 22.7368,
    transform: "translate(0.631348 0.630859)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.686 6.20097L10.8881 11.9989L16.686 17.7968L14.8924 19.5778L7.3134 11.9989L14.8924 4.41992L16.686 6.20097Z",
    fill: "#393E44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1993_40444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 10,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.686 6.20097L10.8881 11.9989L16.686 17.7968L14.8924 19.5778L7.3134 11.9989L14.8924 4.41992L16.686 6.20097Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1993_40444)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLight);
export default __webpack_public_path__ + "static/media/ArrowLeftLight.93b19d2a8d81d56fe1bc64a5a4a056c5.svg";
export { ForwardRef as ReactComponent };